import {useEffect, useState} from 'react';

import {Modal} from 'react-bootstrap';
import CustomButton from './components/customButton';
import {googleAnalyticsInstance} from './utilities/helper/googleAnalitics';
import AppRouter from './routes/AppRouter';

const AppRoutes = () => {
  useEffect(() => {
    try {
      googleAnalyticsInstance.sendPageView(
        window.location.pathname + window.location.search,
      );
    } catch (e) {
      console.error('GA pageview failed', e);
    }
  }, []);

  const [showNotification, setShowNotification] = useState<boolean>(false);
  // const [showDenied, setShowDenied] = useState<boolean>(false);
  useEffect(() => {
    try {
      Promise.resolve(Notification.requestPermission()).then(function (
        permission,
      ) {
        switch (permission) {
          // case 'denied':
          //   setShowDenied(true);
          //   break;
          default:
            //setShowNotification(true);
            break;
        }
      });
    } catch (error) {
      // Safari doesn't return a promise for requestPermissions and it
      // throws a TypeError. It takes a callback as the first argument
      // instead.
      console.log(error);
    }
  }, []);

  const showPopUp = () => {
    try {
      Notification.requestPermission().then();
    } catch (error) {
      // Safari doesn't return a promise for requestPermissions and it
      // throws a TypeError. It takes a callback as the first argument
      // instead.

      console.log(error);
    }

    setShowNotification(false);
  };
  return (
    <>
      <Modal
        centered
        show={showNotification}
        onHide={() => setShowNotification(false)}
      >
        <div className="p-3">
          <h6 className="text-center">
            آیا مایل به دریافت اعلان های مزرعه هستید؟
          </h6>
          <div className="d-flex">
            <CustomButton className="ms-2" onClick={showPopUp}>
              تایید
            </CustomButton>
            <CustomButton outLet onClick={() => setShowNotification(false)}>
              انصراف
            </CustomButton>
          </div>
        </div>
      </Modal>

      <AppRouter />
    </>
  );
};

export default AppRoutes;